import GrossistgruppePicker from 'components/GrossistgruppePicker';
import { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import useToaster from 'utils/hooks/useToaster';

const TestPage = () => {
  const [selectedGrossists, setSelectedGrossists] = useState<string[]>([]);
  const toaster = useToaster();

  const handleSelectionChanged = (grossistGln: string[]): void => {
    setSelectedGrossists(grossistGln);
  };

  console.log(selectedGrossists);

  const findSelectedGrossists = () => {
    return selectedGrossists;
  };

  // Toast test functions
  const showSuccessToast = () => {
    toaster.success('Suksess!', 'Operasjonen ble utført uten problemer.');
  };

  const showInfoToast = () => {
    toaster.info('Informasjon', 'Dette er en informasjonsmelding til brukeren.');
  };

  const showError401 = () => {
    toaster.error('Autentiseringsfeil', 'Du er ikke logget inn. Vennligst logg inn på nytt.');
  };

  const showError403 = () => {
    toaster.error('Tilgangsfeil', 'Du har ikke tilgang til denne ressursen.');
  };

  const showError404 = () => {
    toaster.error('Ikke funnet', 'Ressursen ble ikke funnet.');
  };

  const showError405 = () => {
    toaster.error('Throttling', 'For mange forespørsler. Vennligst vent litt og prøv igjen.');
  };

  const showError429 = () => {
    toaster.error('Rate limit', 'For mange forespørsler. Vennligst vent litt og prøv igjen.');
  };

  const showError500 = () => {
    toaster.error('Serverfeil', 'En serverfeil oppsto. Prøv igjen senere.');
  };

  const showError503 = () => {
    toaster.error('Utilgjengelig', 'Tjenesten er midlertidig utilgjengelig. Prøv igjen senere.');
  };

  const showErrorWithDetails = () => {
    toaster.error(
      'Valideringsfeil',
      <ul style={{ margin: 0, paddingLeft: '1.2em' }}>
        <li>
          <strong>Navn:</strong> Feltet er påkrevd
        </li>
        <li>
          <strong>E-post:</strong> Ugyldig e-postadresse
        </li>
        <li>
          <strong>Telefon:</strong> Må være et gyldig telefonnummer
        </li>
      </ul>,
    );
  };

  const showMultipleToasts = () => {
    toaster.success('Toast 1', 'Første melding');
    setTimeout(() => toaster.info('Toast 2', 'Andre melding'), 300);
    setTimeout(() => toaster.error('Toast 3', 'Tredje melding'), 600);
  };

  return (
    <div className="p-4">
      <h1>Test Page</h1>

      <Card className="mb-4">
        <Card.Header>
          <h5 className="mb-0">🔔 Toast Testing</h5>
        </Card.Header>
        <Card.Body>
          <p className="text-muted mb-3">
            Klikk på knappene nedenfor for å teste forskjellige toast-meldinger.
          </p>

          <h6>Suksess & Info</h6>
          <div className="d-flex gap-2 mb-3 flex-wrap">
            <Button variant="success" onClick={showSuccessToast}>
              ✓ Suksess
            </Button>
            <Button variant="info" onClick={showInfoToast}>
              ℹ Info
            </Button>
          </div>

          <h6>Feilmeldinger (HTTP-statuskoder)</h6>
          <div className="d-flex gap-2 mb-3 flex-wrap">
            <Button variant="danger" onClick={showError401}>
              401 Uautorisert
            </Button>
            <Button variant="danger" onClick={showError403}>
              403 Forbudt
            </Button>
            <Button variant="danger" onClick={showError404}>
              404 Ikke funnet
            </Button>
            <Button variant="warning" onClick={showError405}>
              405 Throttling
            </Button>
            <Button variant="warning" onClick={showError429}>
              429 Rate limit
            </Button>
            <Button variant="danger" onClick={showError500}>
              500 Serverfeil
            </Button>
            <Button variant="danger" onClick={showError503}>
              503 Utilgjengelig
            </Button>
          </div>

          <h6>Avanserte eksempler</h6>
          <div className="d-flex gap-2 mb-3 flex-wrap">
            <Button variant="outline-danger" onClick={showErrorWithDetails}>
              Feil med liste
            </Button>
            <Button variant="outline-primary" onClick={showMultipleToasts}>
              Flere toasts samtidig
            </Button>
          </div>
        </Card.Body>
      </Card>

      <Card>
        <Card.Header>
          <h5 className="mb-0">GrossistgruppePicker Test</h5>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col>
              <GrossistgruppePicker
                onSelectionChanged={handleSelectionChanged}
                findSelectedGrossists={findSelectedGrossists}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TestPage;
